'use client'

import { ChevronRightIcon } from '@heroicons/react/24/outline'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { Stamp } from '@src/components/TopNavV5/Stamp'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { TopNavV5MobileFooter } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileFooter'
import type { TopNavV5MenuItem } from '@src/components/TopNavV5/TopNavV5Props'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'
import { cn } from '@src/utils/tailwind'

export const TopNavV5MobileMenu = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { items, mobileDispatch } = useTopNavV5()

  const itemClasses = 'py-3 text-heading-4 font-lateral font-medium text-left'

  const renderTitle = (menu: TopNavV5MenuItem) => (
    <div className="flex w-fit items-center gap-2">
      {menu.title}
      <Stamp text={menu.stamp} />
    </div>
  )

  return (
    <>
      <div className="flex flex-col gap-2 px-4 py-6 pt-4">
        {items?.map((item, index) => {
          if (item.subMenuType === 'link') {
            return (
              <LocalizedLink
                onClick={() => {
                  trackSelectNavCta({ 'cta url': item.link?.href ?? '' })
                  mobileDispatch({ type: 'CLOSE_FROM_MAIN' })
                }}
                data-testid={`nav-menu-${index}`}
                key={`${item.title}-${index}`}
                className={itemClasses}
                href={item.link?.href ?? ''}
                rel={item.link?.newTab ? 'noopener noreferrer' : ''}
                target={item.link?.newTab ? '_blank' : '_self'}
              >
                {renderTitle(item)}
              </LocalizedLink>
            )
          }

          return (
            <button
              data-testid={`nav-menu-${index}`}
              key={`${item.title}-${index}`}
              className={cn(
                itemClasses,
                'relative flex w-full cursor-pointer items-center gap-2 transition-all'
              )}
              onClick={() => {
                if (item.subMenuType === 'leftMenu') {
                  mobileDispatch({
                    type: 'OPEN_LEFT_MENU',
                    payload: {
                      leftMenu: {
                        title: item.title ?? '',
                        stamp: item.stamp ?? '',
                        items: item.leftMenuItems ?? [],
                      },
                    },
                  })
                } else if (item.subMenuType === 'subMenu') {
                  mobileDispatch({
                    type: 'OPEN_SUB_MENU',
                    payload: { subMenu: item.subMenu ?? null, miniMenu: null },
                  })
                } else if (item.subMenuType === 'miniMenu') {
                  mobileDispatch({
                    type: 'OPEN_SUB_MENU',
                    payload: {
                      subMenu: null,
                      miniMenu: {
                        title: item.title ?? '',
                        items: item.miniMenuItems ?? [],
                      },
                    },
                  })
                }
              }}
            >
              {renderTitle(item)}
              <ChevronRightIcon className="size-5 text-bodi-green-bright-500" />
            </button>
          )
        })}
      </div>
      <TopNavV5MobileFooter />
    </>
  )
}
